export const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: "0.75rem",
      borderColor: "#E3E9F2",
      backgroundColor: "#FFFFFF",
      minHeight: "2.75rem",
      boxShadow: "none",
      fontSize: "0.875rem",
      "&:hover": {
        borderColor: "#114598",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#114598" : "white",
      color: state.isSelected ? "white" : "#14213D",
      cursor: "pointer",
      fontSize: "0.875rem",
      "&:hover": {
        backgroundColor: state.isSelected ? "#114598" : "#F1F6FD",
        color: state.isSelected ? "white" : "#114598",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#14213D",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#5B6577",
      "&:hover": {
        color: "#F68122",
      },
    }),
  };